






















import { Component, Vue } from 'vue-property-decorator'
import pages from '@/constants/pages'
import { categories } from '@/constants/categories'

@Component({})
export default class CategoryLegend extends Vue {
  protected showLegend: boolean = false

  protected toggleLegend () {
    this.showLegend = !this.showLegend
  }

  get categories () {
    return Object.keys(this.boardCategories)
  }

  get boardCategories () {
    return this.$store.getters['boardCategories']
  }
}
